// Copyright © 2024 Broadcom Inc. and its subsidiaries. All Rights Reserved.
import { get } from "lodash";
import * as constants from "../../constants";

const initialState = {
  isLoading: false,
  isError: false,
  errors: [],
  customFields: {
    totalElements: 0,
    results: [],
  },
  isDeleteSuccess: false,
  customFieldsOptions: {},
  addCustomFields: false,
  customFieldNameUnique: "",
  editCustomFields: {},
  updateCustomFields: false,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case constants.FETCH_SETTINGS_CUSTOM_FIELDS_SUCCESS: {
      const customFields = get(action, "payload", {});
      return {
        ...state,
        customFields: {
          totalElements: customFields.totalElements,
          results: customFields.results,
          totalPages: customFields.totalPages,
        },
        errors: [],
        isError: false,
        isLoading: false,
      };
    }
    case constants.FETCH_SETTINGS_CUSTOM_FIELDS_ERROR: {
      return {
        ...state,
        customFields: {
          totalElements: 0,
          results: [],
          totalPages: 0,
        },
        errors: action.payload,
        isError: true,
        isLoading: false,
      };
    }
    case constants.CUSTOM_FIELDS_DELETE_REQUEST: {
      return {
        ...state,
        errors: [],
        isDeleteSuccess: false,
        isError: false,
        isLoading: true,
      };
    }
    case constants.CUSTOM_FIELDS_DELETE_SUCCESS: {
      return {
        ...state,
        errors: action.payload,
        isDeleteSuccess: true,
        isError: true,
        isLoading: false,
      };
    }
    case constants.CUSTOM_FIELDS_DELETE_ERROR: {
      return {
        ...state,
        errors: action.payload,
        isDeleteSuccess: false,
        isError: true,
        isLoading: false,
      };
    }
    case constants.FETCH_CUSTOM_FIELDS_OPTIONS_SUCCESS:
      return {
        ...state,
        customFieldsOptions: action.payload,
        errors: [],
      };
    case constants.FETCH_CUSTOM_FIELDS_OPTIONS_ERROR:
      return {
        ...state,
        customFieldsOptions: {},
        errors: action.payload,
      };
    case constants.ADD_CUSTOM_FIELDS_REQUEST:
      return {
        ...state,
        addCustomFields: "",
        errors: [],
        isLoading: action.loading,
      };
    case constants.ADD_CUSTOM_FIELDS_SUCCESS:
      return {
        ...state,
        addCustomFields: action.payload,
        errors: [],
        isLoading: false,
      };
    case constants.ADD_CUSTOM_FIELDS_ERROR:
      return {
        ...state,
        addCustomFields: "",
        errors: action.payload,
        isLoading: false,
      };
    case constants.CUSTOM_FIELDS_NAME_UNIQUE_SUCCESS:
      return {
        ...state,
        customFieldNameUnique: action.payload,
        errors: [],
      };
    case constants.CUSTOM_FIELDS_NAME_UNIQUE_ERROR:
      return {
        ...state,
        customFieldNameUnique: "",
        errors: action.payload,
      };
    case constants.FETCH_CUSTOM_FIELDS_EDIT_SUCCESS:
      return {
        ...state,
        editCustomFields: action.payload,
        errors: [],
      };
    case constants.FETCH_CUSTOM_FIELDS_EDIT_ERROR:
      return {
        ...state,
        editCustomFields: {},
        errors: action.payload,
      };
    case constants.CUSTOM_FIELDS_UPDATE_REQUEST:
      return {
        ...state,
        updateCustomFields: "",
        errors: [],
        isLoading: action.loading,
      };
    case constants.CUSTOM_FIELDS_UPDATE_SUCCESS:
      return {
        ...state,
        updateCustomFields: action.payload,
        errors: [],
        isLoading: false,
      };
    case constants.CUSTOM_FIELDS_UPDATE_ERROR:
      return {
        ...state,
        updateCustomFields: "",
        errors: action.payload,
        isLoading: false,
      };
    default:
      return state;
  }
}

export const getIsLoading = (state) => get(state, "customFields.isLoading");

export const getCustomFieldsList = (state) =>
  get(state, "customFields.customFields.results");
export const getCustomFieldsListTotalElements = (state) =>
  get(state, "customFields.customFields.totalElements");
export const getCustomFieldsListTotalPages = (state) =>
  get(state, "customFields.customFields.totalPages");

export const getIsDeleteSuccess = (state) => get(state, "customFields.isDeleteSuccess");

export const getIsError = (state) => get(state, "customFields.isError");

export const getErrors = (state) => get(state, "customFields.errors");

export const getCustomFieldsOptionsData = (state) => get(state, "customFields.customFieldsOptions");
export const getAddCustomFieldsData = (state) => get(state, "customFields.addCustomFields");
export const getCustomFieldNameUnique = (state) => get(state, "customFields.customFieldNameUnique.result");
export const getCustomFieldEditData = (state) => get(state, "customFields.editCustomFields");
export const getUpdateCustomFieldsData = (state) => get(state, "customFields.updateCustomFields");
